import SentryService from '@services/SentryService';

import type { StorageBackendType } from './types';

/**
 * Probe browser capabilities to determine the best storage backend.
 *
 * Returns `'opfs'` if the Origin Private File System is available,
 * otherwise falls back to `'indexeddb'`.
 *
 * Handles missing API, SecurityError in private browsing, and
 * any other unexpected errors gracefully.
 */
export async function selectStorageBackend(): Promise<StorageBackendType> {
  try {
    await navigator.storage.getDirectory();

    SentryService.addBreadcrumb({
      category: 'storage.select',
      message: 'OPFS available',
      level: 'info',
    });

    return 'opfs';
  } catch {
    SentryService.addBreadcrumb({
      category: 'storage.select',
      message: 'OPFS not available, falling back to IndexedDB',
      level: 'info',
    });

    return 'indexeddb';
  }
}
